import React, { Fragment } from "react";
import { Label, Col, FormGroup } from "reactstrap";
import DivisionsSelect from "../divisions/Select";
import ManagementsSelect from "../managements/Select";
import FieldWrapper from "../../commons/FieldWrapper";

const JobNestedSelects = props => {
  const { divisionValue, managementValue, col, handleChange } = props;

  const clean_value = { value: "", label: "" };

  const handleChangeDivision = event => {
    handleChange(event, "division");
    handleChange(clean_value, "management");
  };

  const handleChangeManagement = event => {
    handleChange(event, "management");
  };

  return (
    <Fragment>
      <Col md="4">
        <FormGroup>
          <Label htmlFor="division" className="input_required">
            División
          </Label>
          <FieldWrapper errors={divisionValue.errors}>
            <DivisionsSelect
              handleChange={handleChangeDivision}
              value={divisionValue}
              uniqueId="division"
            />
          </FieldWrapper>
        </FormGroup>
      </Col>

      {divisionValue.value && (
        <Col md={col || "4"}>
          <FormGroup>
            <Label htmlFor="management" className="input_required">
              Gerencia
            </Label>
            <FieldWrapper errors={managementValue.errors}>
              <ManagementsSelect
                handleChange={handleChangeManagement}
                value={managementValue}
                divisionId={divisionValue.value}
                uniqueId="management"
              />
            </FieldWrapper>
          </FormGroup>
        </Col>
      )}
    </Fragment>
  );
};

export default JobNestedSelects;
